import { Project } from './Project';

export class Slot {
  constructor(private readonly uuid: string, private readonly id: number, private readonly name: string, private readonly project: Project | null) {}

  getUUID() {
    return this.uuid;
  }

  getId() {
    return this.id;
  }

  getProject() {
    return this.project;
  }

  getLabel() {
    return this.name;
  }

  toRawJson() {
    return {
      id: this.uuid,
      name: this.name,
      project: this.project?.toRawJson() || null,
    };
  }
}
